import React, { useState, useEffect, useRef } from 'react';
import { TYPE_CALL, USER_STATE } from '../../../constants';
import { inboundCall, outBoundCall, phoneIcon, framesCamp } from '../../../Images/Images';
import { SingletonSharedData } from '../../../js/singletonSharedData';
import StopWatch from './StopWatch/StopWatch';
import { hidePhone } from '../../../js/helpers/Utils/formats';
import { Singleton } from '../../../js/Singleton';
import  HeaderAssisted  from './HeaderAssisted.jsx';
import { useSelector } from 'react-redux';
import { UncontrolledTooltip } from 'reactstrap';

function usePrevious(value) {
	const ref = useRef();
	useEffect(() => {
		ref.current = value;
	});
	return ref.current;
}

const CallHeader = props => {
	let language = new Singleton();
	let sharedData = new SingletonSharedData();
	let isHidePhone = sharedData.getGeneralPermissions()[223];

	const receiveAmount = props;
	const prevAmount = usePrevious(receiveAmount);

	const [typeCall, setTypeCall] = useState('');
	const [typeHeader, setTypeHeader] = useState('');
	const [campaignName, setCampaignName] = useState('');
	const [phoneNumber, setPhoneNumber] = useState('');
	const [time, setTime] = useState('');
	const [iconCallFrame, tetIconCallFrame] = useState('');
	const [recordingEnabled, setRecordingEnabled] = useState('');
	const [buttonRecordingActive, setButtonRecordingActive] = useState('');
	const [callKey, setcallKey] = useState('');

	const showData = useSelector(state => state.previewActions.showData);

	useEffect(() => {
		if (prevAmount !== undefined && prevAmount !== receiveAmount && props.currentState !== USER_STATE.ASSISTED) {
			setTypeCall(props.typeCall);
			setTypeHeader(props.typeHeader);
			setCampaignName(props.campaignName);
			setPhoneNumber(props.phoneNumber);
			tetIconCallFrame(props.iconCallFrame);
			setRecordingEnabled(props.recordingEnabled);
			setButtonRecordingActive(props.buttonRecordingActive);
			setcallKey(props.dataCall.CalKey ? props.dataCall.CalKey : props.dataCall.CallKey);
		} else if (props.currentState === USER_STATE.ASSISTED) {
			setCampaignName(props.dataCallAssisted.campaingName);
			tetIconCallFrame(props.dataCallAssisted.iconCampaing);
			setcallKey(props.dataCallAssisted.calKey);
		}
	});
	return (
		<div>
			{sharedData.setCurrentCallTime(time)}
			{props.currentState === USER_STATE.ASSISTED ? (
				<HeaderAssisted iconCallFrame={iconCallFrame} campaignName={campaignName} callKey={callKey} />
			) : (
				!props.problemInManualCall && (
					<div className='callWindowHeader'>
						<div className='infoCallHeaderContainer'>
							<div className='iconCallHeader'>
								<img className='iconCallImage' src={typeCall === TYPE_CALL.INBOUND ? inboundCall : outBoundCall} alt='icon' />
								<img className='iconCallImage iconPadding' src={iconCallFrame > 0 ? framesCamp[iconCallFrame] : ''} alt='iconCallImage' />
							</div>
							<div className='conteinerCampData'>
								<p className='campaignName' id='camp-name-current-call'>
									{campaignName}
									{campaignName.length > 16 && (
										<UncontrolledTooltip delay={{ show: 500, hide: 500 }} placement='top' target={'camp-name-current-call'}>
											{campaignName}
										</UncontrolledTooltip>
									)}
								</p>
								{ showData && <div className='conteinerPhoneCallKey'>
									<div className={'containerPhoneNumber ' + typeHeader}>
										<img className={'iconCampACD ' + typeHeader} src={phoneIcon} alt='icon' />
										<p className='phoneNumber'>{hidePhone(isHidePhone, phoneNumber)}</p>
									</div>
									{(!props.startTimer && callKey !== '' || (sharedData.getDataPreviewPro().dialingMode === 1 && props.currentState ===  USER_STATE.OTHER))
									&& (
										<div className='callKey'>
											<p className='callKeyTitle'>{language.getText('GUICallSpacecallkey')}</p>
											<div className='callKeyBody'>{callKey}</div>
										</div>
									)}
								</div>
								}
							</div>
						</div>
						<div className='timeContainer'>
							<p className={'timeCall ' + typeHeader}>
								<StopWatch
									onChange={time => {
										if (props.currentState !== USER_STATE.WRAPUP) setTime(time);
									}}
									running={props.startTimer}
								/>
								{time.substr(0, 3)}
								<span className={'timeCallBold ' + typeHeader}> {time.substr(3, 5)} </span>
							</p>
							<div className='recordContainer'>
								<div className={recordingEnabled && !buttonRecordingActive ? 'headerRecording on' : 'headerRecording off'}></div>
							</div>
						</div>
					</div>
				)
			)}
		</div>
	);
};
export default CallHeader;



// WEBPACK FOOTER //
// ./src/components/workSpace/CallComponents/CallHeader.jsx